import { useTheme } from '@emotion/react';
import { Typography } from '@mui/material';
import React from 'react'

const AssessmentFooter = ({sx = {}, plain = false}) => {
    const theme = useTheme()
    const brandStyle = plain
        ? { fontWeight: 700, color: theme.palette.customColors.g300 }
        : {
            // backgroundImage, not the `background` shorthand: the shorthand resets
            // background-clip to border-box, which would paint the gradient over the
            // whole span and leave the transparent-filled text invisible.
            fontWeight: 900, backgroundImage: `linear-gradient(135deg, #7852F8 0%, #84AEF6 100%)`,
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
        };
    return (
        <Typography component={"p"}
            sx={{
                color: '#64748b',
                fontSize: '0.8rem',
                marginTop: '1rem',
                marginInline: "auto",
                textAlign: "center",
                // position: "absolute",
                // bottom: 0,
                // left: "50%",
                // transform: "translateX(-50%) translateY(-50%)",
                ...sx
            }}
        >
            Powered by <span style={brandStyle}> Backrr AI </span>
        </Typography>
    )
}

export default AssessmentFooter